var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagesStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 17L10.8123 20.639C10.2951 20.8688 9.70485 20.8688 9.18772 20.639L1 17M19 12L10.8123 15.639C10.2951 15.8688 9.70485 15.8688 9.18772 15.639L1 12M1.78885 6.89443L9.10557 10.5528C9.66863 10.8343 10.3314 10.8343 10.8944 10.5528L18.2111 6.89443C18.9482 6.5259 18.9482 5.4741 18.2111 5.10557L10.8944 1.44721C10.3314 1.16569 9.66863 1.16569 9.10557 1.44721L1.78886 5.10557C1.05181 5.4741 1.05181 6.5259 1.78885 6.89443Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesStack);
export default __webpack_public_path__ + "static/media/messages-stack.a87e86c8cdde41cb067ff3972428c561.svg";
export { ForwardRef as ReactComponent };